// Styles
import './featured-slider.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initFeaturedSlider = (context) => {
  const featuredSliderSection = context.closest('.shopify-section');
  if (!featuredSliderSection) return;

  const swiperContainer = featuredSliderSection.querySelector('.featured-slider__blocks-container');
  if (swiperContainer && swiperContainer.querySelectorAll('.swiper-slide').length > 1) {
    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 'auto',
      spaceBetween: 26,
      navigation: {
        nextEl: swiperContainer.querySelector('.featured-slider-blocks-container__arrow.featured-slider-blocks-container__arrow--right'),
        prevEl: swiperContainer.querySelector('.featured-slider-blocks-container__arrow.featured-slider-blocks-container__arrow--left'),
      },

      breakpoints: {
        769: {
          spaceBetween: 40
        }
      },

      on: {
        init: function (el) {
            const totalHeight = el.height;
            const imageHeight = featuredSliderSection.querySelector('.featured-slider-block__image').offsetHeight;
            const gap = ((totalHeight - imageHeight) /2) * -1 ;
            const Nav_Arrows = featuredSliderSection.querySelectorAll('.featured-slider-blocks-container__arrow');
            Nav_Arrows.forEach((Nav) => {
              Nav.style.marginTop =  `calc(${gap}px)`;
            });
        },
        resize: function (el) {
          const totalHeight = el.height;
          const imageHeight = featuredSliderSection.querySelector('.featured-slider-block__image').offsetHeight;
          const gap = ((totalHeight - imageHeight) /2) * -1 ;
          const Nav_Arrows = featuredSliderSection.querySelectorAll('.featured-slider-blocks-container__arrow');
          Nav_Arrows.forEach((Nav) => {
            Nav.style.marginTop =  `calc(${gap}px)`;
          });
      },
      }
    });
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.featured-slider__container'), (el) => {
    window.dAgency.initFeaturedSlider(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.featured-slider__container'), (el) => {
      window.dAgency.initFeaturedSlider(el);
    });
  });
}
